// Maps common flooring colour words to a representative swatch colour so the
// customer can shade-match at a glance on mobile. Falls back to a neutral
// slate when a colour isn't recognised.
const SWATCHES = {
  grey: "#9ca3af",
  gray: "#9ca3af",
  "light grey": "#d1d5db",
  "dark grey": "#4b5563",
  anthracite: "#383e42",
  charcoal: "#36454f",
  silver: "#c4c8cc",
  slate: "#64748b",
  ash: "#b2beb5",

  beige: "#e6d8b8",
  cream: "#f3ead2",
  ivory: "#f6f2e6",
  sand: "#dcc9a6",
  stone: "#c7c2b6",
  pebble: "#cfcabb",
  mushroom: "#c2b6a3",
  taupe: "#b8a894",

  brown: "#7b5233",
  "dark brown": "#4b3621",
  chocolate: "#4a2c2a",
  mocha: "#6f4e37",
  espresso: "#3b2f2f",
  tan: "#c19a6b",

  oak: "#c8a165",
  "light oak": "#d8b98a",
  "dark oak": "#6b4c2a",
  walnut: "#5c4033",
  maple: "#d9b382",
  honey: "#e3a857",
  natural: "#d2b48c",
  terracotta: "#c96f4c",

  black: "#1f2430",
  white: "#f6f8fa",
  red: "#b91c1c",
  blue: "#2563eb",
  navy: "#1e3a5f",
  teal: "#0f766e",
  green: "#2A5A3B",
};

export function colourSwatch(name) {
  if (!name) return "#cbd5e1";
  const key = String(name).trim().toLowerCase();
  if (SWATCHES[key]) return SWATCHES[key];
  // Tokenise into words so we match on whole words, never substrings
  // (otherwise "weathered" would wrongly match "red").
  const words = key.split(/[\s\-/,]+/).filter(Boolean);
  // Two-word compounds are more specific, so try them first ("dark oak").
  for (let i = 0; i < words.length - 1; i++) {
    const pair = `${words[i]} ${words[i + 1]}`;
    if (SWATCHES[pair]) return SWATCHES[pair];
  }
  for (const w of words) {
    if (SWATCHES[w]) return SWATCHES[w];
  }
  return "#cbd5e1";
}
